import { defineMessages } from 'react-intl';

const simplifiedSignInMessages = defineMessages({
  header: {
    id: 'simplifiedSignIn.header',
    defaultMessage: 'Sign in or create account',
    description: 'Main heading for simplified sign in page.',
  },
  emailLabel: {
    id: 'simplifiedSignIn.emailLabel',
    defaultMessage: 'Email Address',
    description: 'Label for email input field.',
  },
  emailPlaceholder: {
    id: 'simplifiedSignIn.emailPlaceholder',
    defaultMessage: 'Enter your email',
    description: 'Placeholder text for email input field.',
  },
  continueButton: {
    id: 'simplifiedSignIn.continueButton',
    defaultMessage: 'Continue',
    description: 'Continue button label.',
  },
  orContinueWith: {
    id: 'simplifiedSignIn.orContinueWith',
    defaultMessage: 'Or continue with',
    description: 'Separator text between email and social sign-in options.',
  },
  googleLabel: {
    id: 'simplifiedSignIn.googleLabel',
    defaultMessage: 'Google',
    description: 'Google sign-in option label.',
  },
  appleLabel: {
    id: 'simplifiedSignIn.appleLabel',
    defaultMessage: 'Apple',
    description: 'Apple sign-in option label.',
  },
  githubLabel: {
    id: 'simplifiedSignIn.githubLabel',
    defaultMessage: 'GitHub',
    description: 'GitHub sign-in option label.',
  },
  amazonLabel: {
    id: 'simplifiedSignIn.amazonLabel',
    defaultMessage: 'Amazon',
    description: 'Amazon sign-in option label.',
  },
  legalText: {
    id: 'simplifiedSignIn.legalText',
    defaultMessage:
      'By continuing, you agree to the {customerAgreement}, {serviceTerms}, and {privacyNotice}.',
    description: 'Legal agreement text at the bottom of the sign-in form.',
  },
  customerAgreement: {
    id: 'simplifiedSignIn.customerAgreement',
    defaultMessage: 'AWS Customer Agreement',
    description: 'AWS Customer Agreement link text.',
  },
  serviceTerms: {
    id: 'simplifiedSignIn.serviceTerms',
    defaultMessage: 'AWS Service Terms',
    description: 'AWS Service Terms link text.',
  },
  privacyNotice: {
    id: 'simplifiedSignIn.privacyNotice',
    defaultMessage: 'Privacy Notice',
    description: 'Privacy Notice link text.',
  },
  getHelpSigningIn: {
    id: 'simplifiedSignIn.getHelpSigningIn',
    defaultMessage: 'Get help signing in',
    description: 'Help link text.',
  },
  emailRequired: {
    id: 'simplifiedSignIn.emailRequired',
    defaultMessage: 'Email address is required.',
    description: 'Error message when email is empty.',
  },
  emailInvalid: {
    id: 'simplifiedSignIn.emailInvalid',
    defaultMessage: 'Please enter a valid email address.',
    description: 'Error message when email format is invalid.',
  },
  switchToOldUi: {
    id: 'simplifiedSignIn.switchToOldUi',
    defaultMessage: 'Switch to old UI',
    description: 'Link to switch back to the old sign-in UI.',
  },
  faq: {
    id: 'simplifiedSignIn.faq',
    defaultMessage: 'Frequently Asked Questions',
    description: 'Link to frequently asked questions.',
  },
});

export default simplifiedSignInMessages;
